import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseMlsProvider: null,
  franchiseMlsProviders: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseMlsProviderReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEMLSPROVIDER_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEMLSPROVIDER_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEMLSPROVIDER_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default franchiseMlsProviderReducer;
